import { useTranslation } from 'react-i18next'

/**
 * The look of a finished lesson's card, shared by the catalogue row, the
 * home suggestions and the Arcade path (mirrors the Android app's
 * `ui/components/LessonDone.kt`): the whole card turns green — good tint,
 * a heavier good border — the icon tile becomes a filled check, and a small
 * «انجام شد» pill sits where the chevron or the state label would be.
 *
 * `isLessonDone` and the card surface classes (`lessonCardLook`) are in
 * lib/lessonDone.js.
 */

function CheckGlyph({ size }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  )
}

/** The icon tile of a finished lesson: a filled good square with the check. */
export function LessonDoneTile({ className = 'size-[46px] rounded-[13px]', glyph = 21 }) {
  return (
    <span className={`grid shrink-0 place-items-center bg-good text-on-ink ${className}`} aria-hidden="true">
      <CheckGlyph size={glyph} />
    </span>
  )
}

/** «انجام شد» — the finished lesson's label. */
export function LessonDonePill() {
  const { t } = useTranslation('common')
  return <span className="shrink-0 whitespace-nowrap rounded-md bg-good/20 px-2 py-[3px] text-[10.5px] font-semibold text-good-ink">{t('lessonDone')}</span>
}
